import { BaseModel, IBaseModel } from "../base.model";
import { IAddress } from "../address/address.model";

export interface IBlockListingViewModel extends IBaseModel {
  managed_by?: string;
  block_ref?: string | null;
  digicode?: string;
  managers?: any[];
  caretakers?: any[];
  salespersons?: any[]
  name?: string;
  address?: IAddress
  //address?: { city?: string; country?: string; iris_code?: string; line1?: string; line2?: string; zip_code?: string; }
  totalApartment?: number;
  number_apartments?: number;
  totalDocument?: number;
  totalInProgressTicket?: number;
  totalTenant?: number;
}

export class BlockListingViewModel extends BaseModel implements IBlockListingViewModel {
  /**
   *
   */

  managed_by?: string;
  block_ref?: string | null;
  digicode?: string;
  managers?: any[]
  caretakers?: any[];
  salespersons?: any[]
  name?: string;
  address?: IAddress
  //address: { city?: string; country?: string; iris_code?: string; line1?: string; line2?: string; zip_code?: string; }
  totalApartment?: number;
  number_apartments?: number;
  totalDocument?: number;
  totalInProgressTicket?: number;
  totalTenant?: number;

  constructor(partial: Partial<IBlockListingViewModel>) {
    super();
    Object.assign(this, partial);
  }
}


// WEBPACK FOOTER //
// ./src/models/block/block-listing.viewmodel.ts